/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventActionModel
 */
export interface EventActionModel {
    /**
     * 
     * @type {string}
     * @memberof EventActionModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventActionModel
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof EventActionModel
     */
    action: EventActionModelActionEnum;
    /**
     * 
     * @type {string}
     * @memberof EventActionModel
     */
    label: string;
}


/**
 * @export
 */
export const EventActionModelActionEnum = {
    Impression: 'impression',
    Click: 'click',
    ClickTextInput: 'click / text input',
    Add: 'add',
    Remove: 'remove',
    Error: 'error'
} as const;
export type EventActionModelActionEnum = typeof EventActionModelActionEnum[keyof typeof EventActionModelActionEnum];


/**
 * Check if a given object implements the EventActionModel interface.
 */
export function instanceOfEventActionModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function EventActionModelFromJSON(json: any): EventActionModel {
    return EventActionModelFromJSONTyped(json, false);
}

export function EventActionModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventActionModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'category': json['category'],
        'action': json['action'],
        'label': json['label'],
    };
}

export function EventActionModelToJSON(value?: EventActionModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'category': value.category,
        'action': value.action,
        'label': value.label,
    };
}

